import React from 'react';

import {
  Box,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';

import { IDuration } from '../../constants/types';

const selectStyles = {
  minWidth: 80,
  border: 'none',
  '& fieldset': {
    border: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
};

const Duration: React.FC<IDuration> = ({
  formData,
  formErrors,
  onInputChange,
  onSelectChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
      <TextField
        error={Boolean(formErrors?.durationValue)}
        name="durationValue"
        type="number"
        onChange={onInputChange}
        value={formData.durationValue || ''}
        placeholder="Enter Duration"
        helperText={formErrors?.durationValue}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Select
                name="durationType"
                value={formData.durationType || 'Days'}
                onChange={onSelectChange}
                sx={selectStyles}
              >
                {['Days', 'Months', 'Years'].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </InputAdornment>
          ),
        }}
        fullWidth
        sx={{ mb: 2 }}
      />
    </Box>
  );
};

export default Duration;
